import NavBar from '../components/NavBar';
import Footer from '../components/Footer';
import { Typography, Box } from '@mui/material';

import createAccountImage from "../assets/images/reg_flows/create-account.svg";
import enterOTPImage from "../assets/images/reg_flows/enter-otp.svg";
import createPasswordImage from "../assets/images/reg_flows/create-password.svg";
import allSetImage from "../assets/images/reg_flows/all-set.svg";


function GetRegisteredPage() {
  return (
    <>
      <NavBar isSimpleMode={true} />

      <Box
        sx={{
          alignItems: 'center',
          justifyContent: 'center', textAlign: "center",
          backgroundColor: "black",
        }}
      >

        <Typography
          sx={{
            color: "#fff",
            fontSize: { xs: '3rem', sm: '4rem', md: '4.2rem' },
            fontWeight: 200,
            lineHeight: '4rem',
            width: { xs: '90%', md: '100%' },
            padding: '3rem 4rem 1rem',
            m: 'auto'
          }}
        >
          Your four steps to get started.
        </Typography>
      </Box>

      <Box
        sx={{
          p: { xs: "4rem 0", md: "5rem" },
          backgroundColor: "black",
        }}
      >
        <Box
          component="ul"
          sx={{
            width: "85vw",
            margin: "auto",
            display: "flex",
            justifyItems: 'center',
            alignItems: 'center',
            flexDirection: 'column',
            gap: '6rem',
            listStyle: 'none',
            transition: 'transform 0.1s ease-out',
            'scrollbar-width': 'none',
          }}
        >
          <Box
            component="li"
            sx={{
              borderRadius: '15px',
              p: "4rem",
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',
              display: "flex",
              justifyItems: 'center',
              alignItems: 'center',
            }}
          >
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              flexDirection: { xs: "column", md: 'row' },
              gap: '5rem'
            }}>
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "1.8rem",
                    fontWeight: 200,
                    textAlign: "left",
                    width: 'fit-content'
                  }}
                >
                  Step One
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "2.5rem",
                    fontWeight: 600,
                    textAlign: "left",
                    width: '17ch'

                  }}
                >
                  Create your account.
                </Typography>
              </Box>

              <Box sx={{ m: '2rem' }}>
                <Box
                  component="img"
                  src={createAccountImage}
                  alt=""
                  sx={{
                    objectFit: "contain",
                    maxHeight: "50rem",
                    height: "auto",
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box
            component="li"
            sx={{
              borderRadius: '15px',
              p: "4rem",
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',

              display: "flex",
              justifyItems: 'center',
              alignItems: 'center',
            }}
          >
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              flexDirection: { xs: "column", md: 'row' },
              gap: '5rem'
            }}>
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "1.8rem",
                    fontWeight: 200,
                    textAlign: "left",
                    width: 'fit-content'
                  }}
                >
                  Step Two
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "2.5rem",
                    fontWeight: 600,
                    textAlign: "left",
                    width: '17ch'
                  }}
                >
                  Enter your the passcode—SMS.
                </Typography>
              </Box>

              <Box sx={{ m: '2rem' }}>
                <Box
                  component="img"
                  src={enterOTPImage}
                  alt=""
                  sx={{
                    objectFit: "contain",
                    maxHeight: "50rem",
                    height: "auto",
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box
            component="li"
            sx={{
              borderRadius: '15px',
              p: "4rem",
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',

              display: "flex",
              justifyItems: 'center',
              alignItems: 'center',
            }}
          >
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              flexDirection: { xs: "column", md: 'row' },
              gap: '5rem'
            }}>
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "1.8rem",
                    fontWeight: 200,
                    textAlign: "left",
                    width: 'fit-content'
                  }}
                >
                  Step Three
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "2.5rem",
                    fontWeight: 600,
                    textAlign: "left",
                    width: '17ch'
                  }}
                >
                  Create your password.
                </Typography>
              </Box>

              <Box sx={{ m: '2rem' }}>
                <Box
                  component="img"
                  src={createPasswordImage}
                  alt=""
                  sx={{
                    objectFit: "contain",
                    maxHeight: "50rem",
                    height: "auto",
                  }}
                />
              </Box>
            </Box>
          </Box>

          <Box
            component="li"
            sx={{
              borderRadius: '15px',
              p: "4rem",
              background: "rgba(255, 255, 255, 0.1)",
              backdropFilter: 'blur(10px)',
              boxShadow: '0 4px 30px rgba(0, 0, 0, 0.1)',
              border: '1px solid rgba(255, 255, 255, 0.2)',

              display: "flex",
              justifyItems: 'center',
              alignItems: 'center',
            }}
          >
            <Box sx={{
              display: 'flex',
              justifyContent: 'space-around',
              alignItems: 'center',
              flexDirection: { xs: "column", md: 'row' },
              gap: '5rem'
            }}>
              <Box>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "1.8rem",
                    fontWeight: 200,
                    textAlign: "left",
                    width: 'fit-content'
                  }}
                >
                  Step Four
                </Typography>
                <Typography
                  sx={{
                    color: "#fff",
                    fontSize: "2.5rem",
                    fontWeight: 600,
                    textAlign: "left",
                    width: '17ch'
                  }}
                >
                  You're set 🎉.
                </Typography>
              </Box>

              <Box sx={{ m: '2rem' }}>
                <Box
                  component="img"
                  src={allSetImage}
                  alt=""
                  sx={{
                    objectFit: "contain",
                    maxHeight: "50rem",
                    height: "auto",
                  }}
                />
              </Box>
            </Box>
          </Box>

        </Box>
      </Box >

      {/* HOW IT WORKS SECTION */}
      <Box
        id="use-case"
        sx={{
          py: { xs: '5rem', md: '10rem' },
          background: "black"
        }}>

        <Typography
          sx={{
            color: "white",
            fontWeight: 700,
            margin: "4rem auto",
            fontSize: { xs: '3.4rem', sm: '4.6rem' },
            lineHeight: { xs: '4rem', sm: '5.7rem' },
            textAlign: "center"
          }}
        >
          Use case information
        </Typography>

        <Box
          component="ul"
          sx={{
            listStyle: 'none',
            margin: "auto",
            my: "4rem auto",
            width: "95%",
            flexDirection: "column",
            gap: "2rem",
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(30rem, 1fr))',
            maxWidth: "1200px",
          }}
        >
          <Box component="li"
            sx={{

              p: "0.8rem 4rem",

            }}>
            <Typography
              sx={{
                fontSize: "2.4rem",
                fontWeight: 700,
                minHeight: { sm: "8rem", xs: "4rem" }
              }}
            >
              Estimated Monthly Volume
            </Typography>

            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 400,
                color: "#FFFFFFBF"
              }}
            >
              10,000 Messages
            </Typography>
          </Box>

          <Box component="li"
            sx={{

              p: "0.8rem 4rem",

            }}>
            <Typography
              sx={{
                fontSize: "2.4rem",
                fontWeight: 700,
                minHeight: { sm: "8rem", xs: "4rem" }
              }}
            >
              Use Category
            </Typography>

            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 400,
                color: "#FFFFFFBF",
                textAlign: 'justify'
              }}
            >
              Customer Care, Marketing, 2FA, Delivery Notifications, Security Alert.
            </Typography>
          </Box>

          <Box component="li"
            sx={{

              p: "0.8rem 4rem",

            }}>
            <Typography
              sx={{
                fontSize: "2.4rem",
                fontWeight: 700,
                minHeight: { sm: "8rem", xs: "4rem" }
              }}
            >
              Opt-In Type
            </Typography>

            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 400,
                color: "#FFFFFFBF",
                textAlign: 'justify'
              }}
            >
              Via Text
            </Typography>
          </Box>

          <Box component="li"
            sx={{

              p: "0.8rem 4rem",

            }}>
            <Typography
              sx={{
                fontSize: "2.4rem",
                fontWeight: 700,
                minHeight: { sm: "8rem", xs: "4rem" }
              }}
            >
              Use Case Description
            </Typography>

            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 400,
                color: "#FFFFFFBF",
                textAlign: 'justify'
              }}
            >
              SplitEV uses the messaging to provide real-time updates on EV charging
              reservations, charger availability, wait times, and account notifications.
              Customers opt-in via the SplitEV app,
              website, or by texting a keyword. Messages include
              booking confirmations, reminders, and important
              service notifications. Users can opt-out anytime by replying STOP.
            </Typography>
          </Box>

          <Box component="li"
            sx={{

              p: "0.8rem 4rem",

            }}>
            <Typography
              sx={{
                fontSize: "2.4rem",
                fontWeight: 700,
                minHeight: { sm: "8rem", xs: "4rem" }
              }}
            >
              Message Content
            </Typography>

            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 400,
                color: "#FFFFFFBF",
                textAlign: 'justify'
              }}
            >
              Our SplitEV charging session at [Location] is confirmed! Start: [Time]
              Need help? Reply HELP. To opt-out, reply STOP.
            </Typography>
          </Box>

          <Box component="li"
            sx={{

              p: "0.8rem 4rem",



            }}>
            <Typography
              sx={{
                fontSize: "2.4rem",
                fontWeight: 700,
                minHeight: { sm: "8rem", xs: "4rem" }
              }}
            >
              Opt-in Workflow Image URL
            </Typography>

            <Typography
              sx={{
                fontSize: "1.5rem",
                fontWeight: 400,
                color: "#FFFFFFBF",
                textAlign: 'justify'
              }}
            >
              https://splitev.co/get-registered
            </Typography>

            <Box>
              <Box component=""
                sx={{
                  mt: "3rem",


                }}>
                <Typography
                  sx={{
                    fontSize: "2.4rem",
                    fontWeight: 700,
                  }}
                >
                  Contact Email
                </Typography>

                <Typography
                  sx={{
                    fontSize: "1.5rem",
                    fontWeight: 400,
                    color: "#FFFFFFBF",
                    textAlign: 'justify'
                  }}
                >
                  charge@splitev.co
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>

        <Box
          sx={{
            p: "0.8rem 4rem",
            maxWidth: "1200px",
            margin: "2rem auto"
          }}>
          <Typography
            sx={{
              fontSize: "2.4rem",
              fontWeight: 700,
            }}
          >
            Additional information
          </Typography>

          <Typography
            sx={{
              fontSize: "1.5rem",
              fontWeight: 400,
              color: "#FFFFFFBF",
              textAlign: 'justify'
            }}
          >
            SplitEV prioritizes complaince with messaging regulations and follows Twilio's best
            practices for toolfree messaging, including and transparent user controls (opt-out, help commnads).
            Messages are essential for user experience, providing real-time updates on EV charging billing, and service alerts.
          </Typography>
        </Box>
      </Box >

      <Footer />
    </>
  );
}

export default GetRegisteredPage;

